import { DropdownOption } from '@app/app/_components/Dropdown/DropdownOption';
import { ReactNode, useCallback, KeyboardEvent } from 'react';
import { twJoin } from 'tailwind-merge';

interface Props {
    option: DropdownOption;
    selected?: boolean;
    onClick?: (value: DropdownOption) => void;
    children: ReactNode;
}

export function DropdownItem({ option, children, selected, onClick }: Props) {
    const handleClick = useCallback(() => {
        onClick?.(option);
    }, [onClick, option]);

    const handleKeyDown = useCallback((e: KeyboardEvent<HTMLLIElement>) => {
        if (e.code === 'Enter') {
            e.currentTarget.click();

            e.preventDefault();
        }
    }, []);

    return (
        <li
            className={twJoin(
                'inline-flex cursor-pointer text-nowrap rounded px-3 py-2.5 text-sm md:py-1.25',
                selected && 'bg-primary-200',
                !selected && 'hover:bg-neutral-100',
            )}
            role="menuitem"
            tabIndex={0}
            onKeyDown={handleKeyDown}
            onClick={handleClick}
            aria-label={option.ariaLabel}>
            {children}
        </li>
    );
}
